var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-progress-linear',{staticClass:"app-loader-progress-bar pa-0 ma-0",attrs:{"background-color":"#ffb364","indeterminate":true,"height":_vm.progressBarHeight}})}
var staticRenderFns = []

export { render, staticRenderFns }